import { Row, Col } from "antd";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { languages } from "../../../utils/helpers/constants";
import { getTranslations } from "../../../utils/helpers/translations";
import FieldBuilder from "../../form-components/field-builder";
import MainForm from "../../form-components/main-form";
import Spin from "../../general/antd/spin";
import SliceContext from "../../../context/slice/context";
import { IUpdateSlice } from "../../../models/slice/request";
import SliceContextProvider from "../../../context/slice/provider";

const Form = () => {
  const { t } = useTranslation();
  const { details, actions, loading } = useContext(SliceContext);
  const { id } = useParams();

  useEffect(() => {
    const getDetails = async () => {
      id && (await actions.getDetails(Number(id)));
    };
    getDetails();
  }, []);
  return (
    <MainForm
      onSubmit={(data) => {
        details
          ? actions.updateSlice(details?.id, data)
          : actions.createSlice(data);
      }}
      title={details ? t("update_slice") : t("add_slice")}
      defaultValues={
        {
          name: getTranslations(details?.translations?.name),
          percentage: details?.percentage,
        } as IUpdateSlice
      }
    >
      {loading.includes("details") ? (
        <div style={{ height: "50vh" }}>
          <Spin />
        </div>
      ) : (
        <>
          <Row gutter={[16, 8]}>
            {languages?.map((lang, index) => {
              return (
                <Col span={12}>
                  <FieldBuilder
                    key={index}
                    name={`name[${lang?.code}]`}
                    label={`${t("name")} (${lang?.name})`}
                    input={{ type: "text" }}
                    rules={{ required: true }}
                  />
                </Col>
              );
            })}
            <Col span={12}>
              <FieldBuilder
                name="percentage"
                label={t("percentage")}
                input={{ type: "number" }}
                rules={{ required: true }}
              />
            </Col>
          </Row>
        </>
      )}
    </MainForm>
  );
};

const SliceForm = () => {
  return (
    <SliceContextProvider>
      <Form />
    </SliceContextProvider>
  );
};
export default SliceForm;
